import React, { useState, useEffect, useCallback } from 'react';
import { AiOutlineUnorderedList } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { setActivePanel, setProjectId, triggerRefreshTasks } from '../../../store/popupState';
import { Button } from '@nextui-org/react';
import { FiCircle, FiPlus } from 'react-icons/fi';
import { Select, SelectItem } from '@nextui-org/react';
import GorevlerCardComponent from '../../GorevlerCardComponent';
import { getProjectsTasks } from '../../../services/projects';

// Mock priority list
const PriorityList = [
  { key: '1', label: 'Çok Düşük', color: '#cddc39' },
  { key: '2', label: 'Düşük', color: '#8bc34a' },
  { key: '3', label: 'Normal', color: '#2196f3' },
  { key: '4', label: 'Yüksek', color: '#ff9800' },
  { key: '5', label: 'Çok Yüksek', color: '#f44336' }
];


const TaskComponent = ({ projectId }) => {
  const [taskData, setTaskData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [handleClick, setHandleClick] = useState(true);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const dispatch = useDispatch();
  const refreshTasksCounter = useSelector((state) => state.popupState.refreshTasksCounter);
  const animals = PriorityList;
  const status = ['Yeni', 'İşlemde', 'Hazır', 'İncelemede', 'Tamamlandı'];

  // Filtrelenmiş görevleri getir
  const getFilteredTasks = () => {
    if (!taskData || !taskData.tasks) return [];
    
    if (!selectedPriority || selectedPriority === 'all') {
      return taskData.tasks;
    }
    
    return taskData.tasks.filter(task => task.tpriority === parseInt(selectedPriority));
  }; 

  // Görev listesini yenileme fonksiyonu
  const refreshTaskList = useCallback(async () => {
    if (!projectId) return;
    
    try {
      setLoading(true);
      setError(null);
      
      const response = await getProjectsTasks({ slug: projectId });
      setTaskData(response);
      
    } catch (error) {
      setError('Görev bilgileri yenilenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    if (projectId) {
      // projectId'yi store'a kaydet
      dispatch(setProjectId(projectId));
      refreshTaskList();
      
      // Global olarak erişilebilir hale getir
      window.refreshTaskList = refreshTaskList;
    }
  }, [projectId, dispatch, refreshTaskList]);

  // refreshTasksCounter'ı dinle
  useEffect(() => {
    if (refreshTasksCounter > 0 && projectId) {
      refreshTaskList();
    }
  }, [refreshTasksCounter, projectId, refreshTaskList]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8">
        <p className="text-red-500 dark:text-red-400">{error}</p>
      </div>
    );
  }
  return (
    <div className="w-full flex justify-center items-center mt-6">
      <div className="w-full justify-center items-center">
        <div className="flex justify-end">
          <div className="flex space-x-3 pr-4">
            <Button onClick={() => dispatch(setActivePanel([6, 0]))} className="rounded-md text-white text-sm min-w-[120px] h-[45px] dark:bg-darkViolet bg-[#da402f] shadow-md">
              <div className="flex items-end gap-1 text-sm font-semibold">
                <FiPlus size={18} /> <span>Yeni Görev</span>
              </div>
            </Button>
            <Button
              className="h-[45px] rounded-md text-black text-xs dark:bg-dark-500 bg-white"
              onClick={() => {
                setHandleClick(!handleClick)
              }}
            >
              <AiOutlineUnorderedList className="text-[18px] mx-auto dark:text-darkWhite-300 " />
            </Button>
            <div className="min-w-[200px] h-[45px]">
              <Select 
                color='primary' 
                size="sm" 
                label="Öncelik" 
                placeholder="Tümü" 
                startContent={<FiCircle />}
                selectedKeys={selectedPriority ? [selectedPriority] : []}
                onSelectionChange={(keys) => {
                  const selectedKey = Array.from(keys)[0];
                  setSelectedPriority(selectedKey || null);
                }}
                classNames={{
                  trigger: "bg-white dark:bg-dark-300 border-gray-300 dark:border-gray-600",
                  value: "text-gray-900 dark:text-white",
                  label: "text-gray-700 dark:text-gray-300",
                  placeholder: "text-gray-500 dark:text-gray-400"
                }}
              >
                <SelectItem key="all" value="all">
                  Tümü
                </SelectItem>
                {animals.map((animal) => (
                  <SelectItem key={animal.key} value={animal.key}>
                    {animal.label}
                  </SelectItem>
                ))}
              </Select>
            </div>
          </div>
        </div>
        {taskData ? (
          <div>
            {/* Filtreleme sonucu bilgisi */}
            <div className="mb-4 text-sm text-gray-600 dark:text-gray-400">
              {selectedPriority && selectedPriority !== 'all' ? (
                <span>
                  {getFilteredTasks().length} görev bulundu 
                  ({PriorityList.find(p => p.key === selectedPriority)?.label} önceliği)
                </span>
              ) : (
                <span>{getFilteredTasks().length} görev bulundu</span>
              )}
            </div>
            
            <div className={`grid mt-6 gap-3 ${handleClick ? 'lg:grid-cols-3 grid-cols-1 ' : 'grid-cols-1'}`}>
              {getFilteredTasks().map((task, index) => (
              <GorevlerCardComponent
                key={task.id || index}
                title={task.tsubject}
                date={task.created_at}
                deadline={task.deadline_at}
                priority={task.tpriority}
                isPrivate={false}
                status={status[task.tstatus - 1]}
                member={{ member_name: `${task.ufname} ${task.ulname}`, member_img: task.uimg, member_imgtype: task.uimgtype }}
                onClick={() => dispatch(setActivePanel([6, 1, task.id]))}
              />
            ))}
            </div>
          </div>
        ) : (
          <div className="flex justify-end items-center flex-col">
            <div className="grid place-items-center mt-4 ">
              <div className="max-w-[340px] w-full h-auto">
                {/* <Image src={Tasklight} className="dark:hidden" alt="" />
                <Image src={Taskdark} className="hidden dark:block" alt="" /> */}
              </div>

              <div className="text-xl my-5 font-semibold text-gray-39 dark:text-darkWhite-300">Henüz hiç görev eklenmemiş.</div>

              <div className="mb-[110px] -my-4 text-center text-md text-gray-39 dark:text-darkWhite-300 font-medium opacity-50 max-w-[620px] ">
                Bu sayfa sadece sizin görebileceğiniz görevleri eklemenize yardımcı olur. Yeni görev eklemek için sağ üst köşedeki Yeni Görev butonunu kullanabilir ve öncelik
                durumuna göre görevlerinizi ekleyebilirsiniz.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
export default TaskComponent
